/**
 * Lookup table matching the % Uncertainty of EcoQube Pro page.
 * Key: radon level in pCi/L (rounded to 1 decimal), Value: uncertainty string.
 * Above 10.0 pCi/L → "0.8%"
 */
const UNCERTAINTY_TABLE = {
    0.1: "-",
    0.2: "5.9%",
    0.3: "4.8%",
    0.4: "4.2%",
    0.5: "3.7%",
    0.6: "3.4%",
    0.7: "3.1%",
    0.8: "2.9%",
    0.9: "2.8%",
    1.0: "2.6%",
    1.1: "2.5%",
    1.2: "2.4%",
    1.3: "2.3%",
    1.4: "2.2%",
    1.5: "2.2%",
    1.6: "2.1%",
    1.7: "2.0%",
    1.8: "2.0%",
    1.9: "1.9%",
    2.0: "1.9%",
    2.1: "1.8%",
    2.2: "1.8%",
    2.3: "1.7%",
    2.4: "1.7%",
    2.5: "1.7%",
    2.6: "1.6%",
    2.7: "1.6%",
    2.8: "1.6%",
    2.9: "1.5%",
    3.0: "1.5%",
    3.1: "1.5%",
    3.2: "1.5%",
    3.3: "1.5%",
    3.4: "1.4%",
    3.5: "1.4%",
    3.6: "1.4%",
    3.7: "1.4%",
    3.8: "1.4%",
    3.9: "1.3%",
    4.0: "1.3%",
    4.1: "1.3%",
    4.2: "1.3%",
    4.3: "1.3%",
    4.4: "1.3%",
    4.5: "1.2%",
    4.6: "1.2%",
    4.7: "1.2%",
    4.8: "1.2%",
    4.9: "1.2%",
    5.0: "1.2%",
    5.1: "1.2%",
    5.2: "1.2%",
    5.3: "1.1%",
    5.4: "1.1%",
    5.5: "1.1%",
    5.6: "1.1%",
    5.7: "1.1%",
    5.8: "1.1%",
    5.9: "1.1%",
    6.0: "1.1%",
    6.1: "1.1%",
    6.2: "1.1%",
    6.3: "1.0%",
    6.4: "1.0%",
    6.5: "1.0%",
    6.6: "1.0%",
    6.7: "1.0%",
    6.8: "1.0%",
    6.9: "1.0%",
    7.0: "1.0%",
    7.1: "1.0%",
    7.2: "1.0%",
    7.3: "1.0%",
    7.4: "1.0%",
    7.5: "1.0%",
    7.6: "1.0%",
    7.7: "0.9%",
    7.8: "0.9%",
    7.9: "0.9%",
    8.0: "0.9%",
    8.1: "0.9%",
    8.2: "0.9%",
    8.3: "0.9%",
    8.4: "0.9%",
    8.5: "0.9%",
    8.6: "0.9%",
    8.7: "0.9%",
    8.8: "0.9%",
    8.9: "0.9%",
    9.0: "0.9%",
    9.1: "0.9%",
    9.2: "0.9%",
    9.3: "0.9%",
    9.4: "0.9%",
    9.5: "0.9%",
    9.6: "0.9%",
    9.7: "0.8%",
    9.8: "0.8%",
    9.9: "0.8%",
    10.0: "0.8%",
};

export function getUncertainty(radonAvgBq) {
    if (radonAvgBq === undefined || radonAvgBq === null || radonAvgBq === -1) {
        return "N/A";
    }
    const pCi = radonAvgBq / 37;
    const rounded = Math.round(pCi * 10) / 10;

    const result = UNCERTAINTY_TABLE[rounded];
    if (result !== undefined) return result;

    if (rounded > 10.0) return "0.8%";

    return "N/A";
}
